module.exports = __webpack_public_path__ + "img/aviation_mix3.ade10cde.jpg";